import { useState, useCallback } from "react";

const useLoadingTracker = () => {
  const [loadingCount, setLoadingCount] = useState(0);

  const track = useCallback((promise) => {
    setLoadingCount((c) => c + 1);
    return promise.finally(() => setLoadingCount((c) => c - 1));
  }, []);

  return { isLoading: loadingCount > 0, track };
};

export default useLoadingTracker;
